/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import FormController from "../../../FormController/FormController";
import FormTitle from "../../../FormTitle/FormTitle";
import PageLanding from "../../components/PageLanding";

const ByDayOfWeekLanding = () => {
  const history = useHistory();
  const { type } = useSelector((state) => state?.singleGroup);
  const daysOfWeekBoxes = [
    {
      id: "monday",
      title: "Mondays",
      boxName: "Mondays",
      img: "day-of-week/image-monday.jpg",
    },
    {
      id: "tuesday",
      title: "Tuesdays",
      boxName: "Tuesdays",
      img: "day-of-week/image-tuesday.jpg",
    },
    {
      id: "wednesday",
      title: "Wednesdays",
      boxName: "Wednesdays",
      img: "day-of-week/image-wednesday.jpg",
    },
    {
      id: "thursday",
      title: "Thursdays",
      boxName: "Thursdays",
      img: "day-of-week/image-thursday.jpg",
    },
    {
      id: "friday",
      title: "Fridays",
      boxName: "Fridays",
      img: "day-of-week/image-friday.jpg",
    },
    {
      id: "saturday",
      title: "Saturdays",
      boxName: "Saturdays",
      img: "day-of-week/image-saturday.jpg",
    },
    {
      id: "sunday",
      title: "Sundays",
      boxName: "Sundays",
      img: "day-of-week/image-sunday.jpg",
    },
  ];

  useEffect(() => {
    if (!type) history.push("/");
  }, [history, type]);

  return (
    <div>
      <FormTitle title="Select Day of Week" />
      <PageLanding
        boxesArr={daysOfWeekBoxes}
        goToPage={"by-day-of-week"}
        trackingTitle="Select Day of Week"
      />
      <FormController
        backTo="/ticket-single-group"
        startOver="/"
        showBack
        showStartOver
        
      />
    </div>
  );
};

export default ByDayOfWeekLanding;
